import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RoutePaths from "./routes";
import CreateClient from "./utils/apollo";
import { ApolloProvider } from "@apollo/client";
import { AuthProvider } from "./hooks/use-auth";
import { ApiProvider } from "./hooks/use-api";
import { CompanyProvider } from "./hooks/use-company";
import NoData from "./views/no-data/no-data";

function App() {
  return (
    <ApolloProvider client={CreateClient()}>
      <Router>
        <AuthProvider>
          <ApiProvider>
            <CompanyProvider>
              <Routes>
                {RoutePaths.map((routePath, index) => (
                  <Route
                    key={index}
                    path={routePath.path}
                    element={
                      <routePath.layout>
                        <routePath.component key={+Date.now()} />
                      </routePath.layout>
                    }
                  ></Route>
                ))}
                <Route path="*" element={<NoData />} />
                {/* <Route path="/login" element={ <DefaultLayout ><Login/></DefaultLayout> }/> */}
              </Routes>
            </CompanyProvider>
          </ApiProvider>
        </AuthProvider>
      </Router>
    </ApolloProvider>
  );
}

export default App;
